module.exports = __webpack_public_path__ + "img/myluxura-module.sticker-id.45b56108.svg";